<template>
    <div class="app-card-title" v-if="heading" style="border-bottom: 1px solid rgba(0, 0, 0, 0.12)">
        <h3>
            <v-icon v-if="headerIcon" class="mr-2">{{ headerIcon }}</v-icon
            >{{ heading }}<v-chip v-if="count" small>{{ count }}</v-chip>
        </h3>
        <template v-if="!withTabs">
            <slot></slot>
        </template>
        <template v-else>
            <div class="app-contextual-link">
                <ul class="custom-tab-wrap list-inline">
                    <template v-for="(tab, key) in tabs">
                        <li @mouseup.left="onChangeTab(key)" :key="key">
                            <a
                                href="javascript:void(0)"
                                class="fs-12 fw-semi-bold px-2 py-1 rounded mx-1"
                                :class="[{ 'primary white--text': activeTab === key }]"
                                >{{ tab }}</a
                            >
                        </li>
                    </template>
                </ul>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: [
        "heading",
        "closeable",
        "reloadable",
        "fullScreen",
        "withTabs",
        "tabs",
        "onCollapse",
        "onReload",
        "onClose",
        "onChangeTabCallback",
        "headerIcon",
        "reloadMethod",
        "count",
    ],
    data() {
        return {
            activeTab: 0,
        };
    },
    methods: {
        onChangeTab(value) {
            this.activeTab = value;
            this.$emit("onChangeTabCallback", value);
        },
    },
};
</script>
